/* eslint-disable rxjs-angular-x/prefer-composition */
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";

import { Context } from "@hermes/core-app-core";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { UserStateService } from "@hermes/hermes-web-states-user-state";

import { InterceptorService } from "./interceptor.service";

/**
 * This interceptor displays a not found page when a backend returns a 404 response
 */
@Injectable()
export class CreateUserSessionOn401UnauthorizedInterceptor
    implements HttpInterceptor
{
    readonly #context = inject(Context);
    readonly #interceptorService = inject(InterceptorService);
    readonly #userService = inject(UserStateService);

    /**
     * Angular HTTP interceptor
     */
    public intercept<T>(
        request: HttpRequest<T>,
        next: HttpHandler,
    ): Observable<HttpEvent<T>> {
        // If the current interceptor is disabled for current route,
        // we only call next.handle without any custom process
        if (!this.#interceptorService.isEnabled(this)) {
            return next.handle(request);
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse): Observable<never> => {
                if (!this.#context.isInBrowserMode()) {
                    return throwError(() => error);
                }

                if (error.status === 401) {
                    return this.#userService
                        .fetchCustomerSession()
                        .pipe(switchMap(() => throwError(() => error)));
                }

                // default case : technical error, rethrow the error so that it can be catched by the susbscribers or ErrorHandler if there is no error management on call
                return throwError(() => error);
            }),
        );
    }
}
